import React from "react";
import styles from "./WeekDays.module.scss";
import { WorkloadDayType } from "modules/spending/workload/models/workload-day";

/**
 * Шапка с числами месяца.
 *
 * Принимает простые значения, а не узлы MST: массив дней приходит от узла
 * сотрудника, а тот пересоздаётся при каждой загрузке табеля. В dev-сборке
 * React 19 сменившийся проп-массив разбирается по свойствам, обход узлов MST
 * поднимает их ленивые поля вне фазы инициализации, и приложение перестаёт
 * перерисовываться при переходах (подробнее — в DepartmentBlock).
 *
 * Значения считает вызывающий: он наблюдатель, и реактивность остаётся у него.
 */
export const WeekDays = ({ days, isMainPage }: WeekDaysProps) => {
  return (
    <div className={`week-days ${styles.row}`} style={isMainPage ? { marginBottom: "-15px" } : {}}>
      <div className={`timesheet-user-name ${styles.part}`} />
      {days.map((day, index) => {
        const next = index + 1 < days.length ? days[index + 1] : undefined;

        const preWeekend = next && next.isDayOff ? styles.preWeekend : "";
        const preToday = next && next.isToday ? styles.preToday : "";
        const weekend = day.isDayOff ? styles.weekend : "";
        const today = day.isToday ? styles.today : "";

        return (
          <div
            key={day.dayOfMonth}
            className={`timesheet-cell ${styles.cell} ${styles.part} ${weekend} ${preWeekend} ${preToday} ${today}`}
          >
            {day.dayOfMonth}
          </div>
        );
      })}
    </div>
  );
};

/** Число месяца в шапке: только то, что нужно для отрисовки. */
export interface WeekDayView {
  dayOfMonth: string;
  isDayOff: boolean;
  isToday: boolean;
}

export const toWeekDayViews = (days: WorkloadDayType[]): WeekDayView[] =>
  days.map((day) => ({
    dayOfMonth: day.dayOfMonth,
    isDayOff: day.isDayOff,
    isToday: day.isToday(),
  }));

interface WeekDaysProps {
  days: WeekDayView[];
  isMainPage?: boolean;
}
